import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/career_p_e.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Elementary',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "데이터 사이언스 체험 활동", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "데이터 사이언스 체험 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "인간행동을 측정·분석·예측하다!")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-33824d22><dl data-v-33824d22><dt data-v-33824d22>목적</dt><dd data-v-33824d22> 개인의 다중재능검사 개발 활동을 통해 자신의 재능 전반에 대한 이해와 진로 탐색은 물론,<br data-v-33824d22> 인간행동을 측정, 예측하는 ‘데이터 사이언스’ 전문가의 역량 및 하는 일을 체험하는 기회를 제공한다. </dd></dl><dl data-v-33824d22><dt data-v-33824d22>목표</dt><dd data-v-33824d22> ① 관심 진로 및 직업군을 탐색, 선택하여 주된 일을 파악한다. <br data-v-33824d22> ② 팀별로, 관심 진로 및 직업군의 행동 특징을 발굴하여 검사를 개발한다. <br data-v-33824d22> ③ 팀별 개발 검사로 진단 실시 후, 범주별 평균을 그래프로 제시한다. <br data-v-33824d22> ④ 팀별 발표로 또래 집단의 다양한 생각을 공유한다. </dd></dl><dl data-v-33824d22><dt data-v-33824d22>대상</dt><dd data-v-33824d22>초6</dd></dl><dl class=\"line2\" data-v-33824d22><dt data-v-33824d22>시간</dt><dd data-v-33824d22>3시간</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-33824d22><ul class=\"line line4\" data-v-33824d22><li data-v-33824d22>팀 과제</li><li data-v-33824d22><dl class=\"line2\" data-v-33824d22><dt data-v-33824d22>재료</dt><dd data-v-33824d22> • 자료 1. 직업군 16종 <br data-v-33824d22> • 자료 2. [활동지 1] 검사 개발 양식<br data-v-33824d22> • 자료 3. [활동지 2] MY 재능검사 <br data-v-33824d22> • 자료 4. [활동지 3] 결과리포트 양식 </dd></dl></li></ul></div><div data-v-33824d22><ul class=\"line\" data-v-33824d22><li data-v-33824d22> 결과물<br data-v-33824d22> + 결과리포트<br data-v-33824d22> + 직업군 행동 특성 </li><li data-v-33824d22><dl class=\"line2\" data-v-33824d22><dt data-v-33824d22>구성</dt><dd data-v-33824d22> • 모듈 1. [활동 안내] 데이터 사이언스 체험 활동 안내 <br data-v-33824d22> • 모듈 2. [검사 개발] 문항 개발/답지/채점 &gt;&gt; 검사지 개발<br data-v-33824d22> • 모듈 3. [검사 실시 및 분석] 검사 실시 &gt;&gt; 결과 요약 &gt;&gt; 재능지수 및 진로 탐색<br data-v-33824d22> • 모듈 4. [결과 발표] 검사 소개 &gt;&gt; 검사 결과 소개 </dd></dl></li></ul></div><div data-v-33824d22><ul class=\"line\" data-v-33824d22><li data-v-33824d22>진행: 관리자</li><li data-v-33824d22><dl class=\"line2\" data-v-33824d22><dt data-v-33824d22>활용</dt><dd data-v-33824d22></dd></dl></li></ul></div>", 3)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Career.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})